import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4f4b1ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "training" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "TRAINEESHIP", -1))

import { reactive } from 'vue';
  import CardImg from '@/components/CardImg.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TrainingView',
  setup(__props) {

  const training = reactive([
      {
        id:0, 
        title:'Occupational Traineeship', 
        img:'training-brief.jpg', 
        route:'/training-brief', 
        desc:'Brief introduction of the Occupational Traineeship'
      },
      {
        id:1, 
        title:'Occupational Traineeship for Nurses', 
        img:'nurse.jpg', 
        route:'/nurse', 
        desc:'The latest information about nurse traineeship'
      },
      {
        id:2, 
        title:'Occupational Traineeship for Cooks', 
        img:'cook.jpg', 
        route:'/cook', 
        desc:'The latest information about cook traineeship'
      }
  ]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(CardImg, { value: training }, null, 8, ["value"])
  ]))
}
}

})